import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.land-parcels-index-page', () => {
  import('./internal/land-parcels-index-page').then(({ default: Component }) => Component());
});
